export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7814.15fb7a04.jpg";